<template>
  <div class="resend-container">
    <el-form ref="detailDataFormRef" :model="formData">
      <!--发票密钥-->
      <div style="display: flex">
        <div class="row-style">
          {{ $t('mdfeTranslate.MDFEKey') }}
        </div>
        <div class="airport-option">
          {{ formData.mdfeKey }}
        </div>
      </div>
      <div style="display: flex;">
        <!--MDFe 当前状态-->
        <div class="row-style">
          {{ $t('mdfeTranslate.CurrentStatusMDFe') }}
        </div>
        <div class="row-label">
          <el-tag v-if="formData.currentMdfeStatus === 1" size="mini" type="success">
            {{ mdfeStatus[formData.currentMdfeStatus].label }}
          </el-tag>
          <el-tag v-if="formData.currentMdfeStatus === 2" size="mini" type="danger">
            {{ mdfeStatus[formData.currentMdfeStatus].label }}
          </el-tag>
          <el-tag v-if="formData.currentMdfeStatus === 3" size="mini" type="info">
            {{ mdfeStatus[formData.currentMdfeStatus].label }}
          </el-tag>
        </div>
        <!--总重量-->
        <div class="row-style">
          {{ $t('mdfeTranslate.TotalWeight') }}
        </div>
        <div class="airport-option">
          {{ formData.totalWeight }}
        </div>
      </div>
      <div style="display: flex;">
        <!--目标航司-->
        <div class="row-style">
          {{ $t('mdfeTranslate.TargetAirline') }}
        </div>
        <div class="row-label">
          {{ formData.airlineName }}
        </div>
        <!--始发地机场代码-->
        <div class="row-style">
          {{ $t('mdfeTranslate.DepartureAirportCode') }}
        </div>
        <div class="airport-option">
          <el-form-item
            :label="$t('mdfeTranslate.StateOfOrigin')"
            prop="startState"
            label-position="top"
          >
            <el-select
              v-model="formData.startState"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              filterable
              size="small"
              style="width: 100%;"
            >
              <el-option
                v-for="item in stateList"
                :key="item.id"
                :label="item.label"
                :value="item.label"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('mdfeTranslate.departureAirport')"
            prop="originIata"
            label-position="top"
            :rules="[
              { required: true, message: $t('collectionCenter.notNull'), trigger: 'change' }
            ]"
          >
            <ElSelectV2
              v-model="formData.originIata"
              :options="airportOptions"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              filterable
              size="small"
              class="option-style"
              style="width: 100%"
              @visible-change="val => getAirportOptionsChange(val,formData.startState)"
            />
          </el-form-item>
        </div>
      </div>
      <div style="display: flex;">
        <!--关联CTe数量-->
        <div class="row-style" style="border-bottom: none;">
          {{ $t('mdfeTranslate.NumberOfAssociatedCTe') }}
        </div>
        <div class="row-label" style="border-bottom: none;">
          {{ formData.cteCount }}
        </div>
        <!--目的地机场代码-->
        <div class="row-style" style="border-bottom: none;">
          {{ $t('mdfeTranslate.DestinationAirportCode') }}
        </div>
        <div class="airport-option" style="border-bottom: none;">
          <el-form-item
            :label="$t('mdfeTranslate.DestinationState')"
            prop="endState"
            label-position="top"
          >
            <el-select
              v-model="formData.endState"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              filterable
              size="small"
              style="width: 100%;"
            >
              <el-option
                v-for="item in stateList"
                :key="item.id"
                :label="item.label"
                :value="item.label"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('mdfeTranslate.destinationAirport')"
            prop="destIata"
            label-position="top"
            :rules="[
              { required: true, message: $t('collectionCenter.notNull'), trigger: 'change' }
            ]"
          >
            <ElSelectV2
              v-model="formData.destIata"
              :options="airportOptions"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              filterable
              size="small"
              style="width: 100%"
              @visible-change="val => getAirportOptionsChange(val,formData.endState)"
            />
          </el-form-item>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import { getLgAreaListData } from '@/api/orderApi';
import { airlineCargoUnits, airlinePush, airlineRetryPush } from '@/api/invoiceCenter';
import ElSelectV2 from 'el-select-v2';

export default {
  name: 'Resend',
  components: { ElSelectV2 },
  props: {
    detailData: {
      type: Object,
      default: () => {}
    },
    mdfeStatus: {
      type: Object,
      default: () => {
        return {
          1: {
            label: this.$t('mdfeTranslate.Authorized'),
            value: 1
          },
          2: {
            label: this.$t('collectionCenter.cancelled'),
            value: 2
          },
          3: {
            label: this.$t('mdfeTranslate.Closed'),
            value: 3
          }
        };
      }
    },
    statusOptions: {
      type: Object,
      default: () => {
        return {
          0: {
            label: this.$t('mdfeTranslate.PendingPush'), // '待推送',
            value: 0
          },
          1: {
            label: this.$t('mdfeTranslate.Pushed'), // '已推送',
            value: 1
          },
          2: {
            label: this.$t('mdfeTranslate.PushFailed'), // '推送失败',
            value: 2
          },
          3: {
            label: this.$t('mdfeTranslate.Canceled'), // '已取消',
            value: 3
          }
        };
      }
    },
    pushType: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      stateList: [],
      airportOptions: [],
      formData: {}
    };
  },
  created() {
    this.getAddress();
    this.formData = JSON.parse(JSON.stringify(this.detailData));
  },
  methods: {
    // 打开机场选项弹窗
    getAirportOptionsChange(val, state) {
      console.log(val, state);
      if (val) {
        this.getAirportOptions(state);
      }
    },
    // 获取州选项
    getAddress() {
      // level 0 州    1 城市   2 地区
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.stateList = res.data.map((item) => {
            return {
              id: item.id,
              label: item.nameEn
            };
          });
        }
      });
    },
    // 获取机场
    getAirportOptions(state) {
      this.airportOptions = [];
      const param = {
        configCode: this.formData.configCode, // 配置编码
        stateUf: state // 州UF
      };
      if (state) {
        airlineCargoUnits(param).then(res => {
          if (res.code === 200) {
            if (res.data && res.data.length > 0) {
              this.airportOptions = res.data.map(item => {
                return {
                  label: item.name,
                  value: item.code
                };
              });
            }
          }
        });
      } else {
        this.airportOptions = [{ label: this.$t('mdfeTranslate.PleaseSelectStateFirst'), value: '', disabled: true }];
      }
    },
    // 推送
    handleResendPush() {
      this.$refs.detailDataFormRef.validate(valid => {
        if (valid) {
          // 2: 航空推送 3：重新推送
          const param = {
            mdfeKey: this.formData.mdfeKey,
            originIata: this.formData.originIata,
            destIata: this.formData.destIata
          };
          this.$confirm(this.$t('mdfeTranslate.PleaseConfirmWhetherToPushTheCTeDataTo') + ' ' + this.formData.airlineName + '?', this.$t('mdfeTranslate.ConfirmPush'), {
            confirmButtonText: this.$t('GlobalSetObj.determine'), // '确定',
            cancelButtonText: this.$t('orderCenterCont.cancel'), // '取消',
            type: 'warning'
          }).then(() => {
            if (this.pushType === 2) {
              airlinePush(param).then(res => {
                if (res.code === 200) {
                  if (res.data.success === true) {
                    this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
                  } else {
                    this.$message.error(res.data.failReason);
                  }
                }
              }).finally(() => {
                this.$emit('resendPushSave', true);
              });
            } else {
              airlineRetryPush(param).then(res => {
                if (res.code === 200) {
                  if (res.data.success === true) {
                    this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
                  } else {
                    this.$message.error(res.data.failReason);
                  }
                }
              }).finally(() => {
                this.$emit('resendPushSave', true);
              });
            }
          });
        }
      });
    }
  }
};
</script>

<style>
.resend-container {
  border: 1px solid #ccc;
  border-radius: 10px;
  overflow: hidden;
}
.resend-container .is-disabled .el-input__inner {
  color: #6e6e6e;
}
.row-style {
  width: 180px;
  background:#fafafa;
  padding: 10px;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}
.row-label {
  width: 180px;
  padding: 10px;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}
.airport-option {
  flex: 1;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
</style>
